import React from 'react';
import { Flex, Box } from 'grid-styled';
import { Headline } from '../Text';

const Body = Flex.extend`
  height: 100%;
  white-space: pre-line;
  text-align: center;
`;

export default () => (
  <Body width="100%">
    <Box my="auto" mx="auto">
      <Headline color="grey300">
        {`No table available.
          Please select another time interval.`}
      </Headline>
    </Box>
  </Body>
);



// WEBPACK FOOTER //
// ./src/components/LocationTable/EmptyTable.jsx